<template>
  <v-select
    v-model="data"
    v-bind="$attrs"
    :items="dayItems"
    item-text="label"
    item-value="value"
    :multiple="multi"
  />
</template>

<script>
import ModelMixin from '../../mixins/model';

export default {
  mixins: [
    ModelMixin,
  ],

  props: {
    value: [Number, Array],
    multi: Boolean,
  },

  data() {
    return {
      data: undefined,
    };
  },

  computed: {
    dayItems() {
      const days = new Array(31);
      for (let i = 1; i <= 31; i++) {
        days[i - 1] = { label: i.toString(), value: i };
      }
      return days;
    },
  },
};
</script>
